import loadable from "@loadable/component";
import { useParams } from "react-router";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
//@ts-ignore
import InvoiceSkeleton from "../../components/Reusable/InvoiceSkeleton";
import SwitchTab from "../../components/Reusable/SwitchTab";
const InvoicePreviewComponent = loadable(
  () => import("../../components/MerchantInvoice/InvoicePreview")
);

const MerchnatInvoicePreview = () => {
  const { id } = useParams();

  const { data: order, isLoading } = useGetHook({
    queryKey: ["merchant-invoice", `merchant-inovice-${id}`],
    url: `${APIS.MERCHANT_INVOICE}${id}/`,
    params: {},
  });

  return (
    <>
      <SwitchTab id={id} />
      {isLoading ? (
        <InvoiceSkeleton />
      ) : (
        <InvoicePreviewComponent order={order} id={id} />
      )}
    </>
  );
};

export default MerchnatInvoicePreview;
